<template>
  <div class="employee-view container">
    <div class="row">
      <div class="col-md-9">
        <div class="employee-info">
            <!-- All your info-blocks stay here -->
            <div class="row">
  <div class="col-md-6 mb-3" v-for="(field, index) in employeeFields" :key="index">
    <div class="d-flex">
      <label class="me-2 fw-semibold text-uppercase small text-muted">{{ field.label }}:</label>
      <span class="fw-medium">{{ field.value }}</span>
    </div>
  </div>
</div>

             
        </div>
      </div>

      <div class="col-md-3 d-flex justify-content-center align-items-start">
        <div class="profile-image-container mb-3">
          <img :src="avatarUrl" alt="Profile Image"
               class="img-thumbnail"
               style="width: 150px; height: 150px; object-fit: cover; border-radius: 50%;">
        </div>
      </div>
    </div>

    <br><br>

    <h4 class="fw-bolder">Days off</h4>
    <table id="projectTable" class="table table-hover align-middle mb-0 mis_table" style="width:100%">
      <thead>
        <tr>
          <th><div>From</div></th>
          <th><div>To</div></th>
          <th><div>Type</div></th>
          <th><div>Days</div></th>
          <th class="no-after"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(dayoff, index) in selectedEmployee.data.daysoff" :key="dayoff.id">
          <td>{{ formatDate(dayoff.from) || '' }}</td>
          <td>{{ formatDate(dayoff.to) || '' }}</td>
          <td>{{ dayoff?.kind?.title || '' }}</td>
          <td>{{ dayoff.days || '' }}</td>
        </tr>
        <tr v-if="!selectedEmployee.data.daysoff || selectedEmployee.data.daysoff.length === 0">
          <td colspan="6" class="text-center">No days off available</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getEmployee } from '@/services/employees';
import { useToast } from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import Editor from '@tinymce/tinymce-vue';
import Select2 from 'vue3-select2-component';
import { mapGetters } from 'vuex';
import { getClientsServicesStatusesUsers } from '@/services/projects';


export default {
    components: {
        Editor,
        Select2
    },
    computed: {
      employeeFields() {
    const d = this.selectedEmployee.data;
    return [
      { label: "Name", value: d.name },
      { label: "Surname", value: d.surname },
      { label: "Email", value: this.formattedEmail },
      { label: "Hire Date", value: this.formatDate(d.hireDate) },
      { label: "Father's Name", value: d.fatherFullName },
      { label: "Mother's Name", value: d.motherFullName },
      { label: "Spouse Fullname", value: d.spouseFullName },
      { label: "Identity Type", value: d.identityType },
      { label: "Identity Code", value: d.identityNum },
      { label: "Ημερ. Εκδοσης Ταυτοτητας", value: this.formatDate(d.identityCreationDate) },
      { label: "Eκδουσα Αρχη", value: d.identityCreationDepartment },
      { label: "ΑΦΜ", value: d.afm },
      { label: "ΔΟΥ", value: d.doy },
      { label: "ΑΜ ΙΚΑ", value: d.amIka },
      { label: "ΑΜΚΑ", value: d.amka },
      { label: "ΑΜ ΑΛΛΟΥ ΑΣΦΑΛΙΣΤΙΚΟΥ ΤΑΜΕΙΟΥ", value: d.amMiscDepartment },
      { label: "Tax Email", value: d.taxEmail },
      { label: "Συνολο Δικαιουμενων Αδειων", value: d.total_days_off },
      { label: "Ημερ. Γεννησεως", value: this.formatDate(d.birthday) },
      { label: "Τοπος Γεννησεως", value: d.birthplace },
      { label: "Ιθαγενεια", value: d.nationality },
      { label: "Διευθυνση Κατοικιας", value: d.address },
      { label: "Περιοχη", value: d.area },
      { label: "ΤΚ", value: d.postal },
      { label: "Δημοτικο Διαμερισμα", value: d.municipality },
      { label: "Τηλεφωνο", value: d.tel },
      { label: "Οικογενειακη Κατασταση", value: d.maritalStatus },
      { label: "Αρ. Αδειας Οδηγησης", value: d.drivingLicense },
      { label: "Ετος Πρωτης Ασφαλισης", value: d.yearOfFirstInsurance },
      { label: "Αρ. Προστατευομενων Τεκνων", value: d.numberOfChildren },
      { label: "Προϋπηρεσια Συνολο", value: d.insuranceContributionsTotal },
      { label: "Προϋπηρεσια Ειδικοτητας", value: d.insuranceContributionsSpecialty },
    ];
  },
        
        formattedPhone: {
      get() {
        // Check if phone is a string 'null' and convert it to an empty string
        return this.selectedEmployee?.data?.phone === 'null' ? '' : this.selectedEmployee?.data?.phone;
      },
      set(value) {
        // When setting, store the value directly to selectedEmployee.data.phone
        this.selectedEmployee.data.phone = value;
      },
    },
      formattedPostal: {
      get() {
        return this.selectedEmployee?.data?.postal === 'null' ? '' : this.selectedEmployee?.data?.postal;
      },
      set(value) {
        this.selectedEmployee.data.postal = value;
      }
    },
    formattedAddress: {
      get() {
        return this.selectedEmployee?.data?.address === 'null' ? '' : this.selectedEmployee?.data?.address;
      },
      set(value) {
        this.selectedEmployee.data.address = value;
      }
    },
    formattedTaxInfo: {
      get() {
        return this.selectedEmployee?.data?.taxInfo === 'null' ? '' : this.selectedEmployee?.data?.taxInfo;
      },
      set(value) {
        this.selectedEmployee.data.taxInfo = value;
      }
    },
    formattedOccupation: {
      get() {
        return this.selectedEmployee?.data?.occupation === 'null' ? '' : this.selectedEmployee?.data?.occupation;
      },
      set(value) {
        this.selectedEmployee.data.occupation = value;
      }
    },
    formattedFoundUs: {
      get() {
        return this.selectedEmployee?.data?.foundUs === 'null' ? '' : this.selectedEmployee?.data?.foundUs;
      },
      set(value) {
        this.selectedEmployee.data.foundUs = value;
      }
    },
    formattedEmail: {
      get() {
        return this.selectedEmployee?.data?.email === 'null' ? '' : this.selectedEmployee?.data?.email;
      },
      set(value) {
        this.selectedEmployee.data.email = value;
      }
    }
  

    },
    name: 'ClientProfile',
   
    setup() {
        const route = useRoute();
        const selectedEmployee = ref({
        data: {
            title: '',
            nickname: '',
            email: '',
            occupation: '',
            address: '',
            postal: '',
            phone: '',
            foundUs: '',
            taxInfo: '',
            paid: '',
            potential: '',
            avatar_file_name: '',
            payManagerId: ''

        }
    }); 
        const editableClient = ref({});
        const isEditing = ref(false);
        const toast = useToast();
        const specialtiesOptions = ref([]);
        const selectedSpecialties = ref([]);
        const selectedJobCategories = ref([]);
        const avatar = ref('');
        const avatarUrl = ref('/img/profile_av.7b0dcddf.png');      
        const allData = ref({});
const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  if (isNaN(date)) return dateStr;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};


        const fetchEmployee = async () => {
            try {
                const response = await get(route.query.id);
                if (response.data.data && response.data.data.avatar_file_name) {
                        avatarUrl.value = '/storage/avatars/' + response.data.data.avatar_file_name;
                    }
                if (response.data) {
                    selectedEmployee.value = response.data;
                 
                } else {
                    toast.error('Failed to load employee profile.');
                }
            } catch (error) {
                toast.error('An error occurred while fetching the employee profile.');
            }
        };

        const startEditing = () => {
            editableClient.value = { ...selectedEmployee.value.data };
            isEditing.value = true;
        };

        const cancelEditing = () => {
            isEditing.value = false;
        };

        const openConfirmationModal = () => {
            $('#confirmationModal').modal('show');
        }; 

        onMounted(async () => {
            
            fetchEmployee();
            const tmpAllData = await getClientsServicesStatusesUsers();
            let newData = { users: [], statuses: [], clients: [], services: [] };
            for (let i = 0; i < tmpAllData.data.users.length; i++) {
                newData.users.push({ id: tmpAllData.data.users[i].id, text: tmpAllData.data.users[i].username });
            }
            allData.value = newData;

        });

        return {
            avatar,
            avatarUrl,
            specialtiesOptions,
            selectedEmployee,
            editableClient,
            isEditing,
            selectedSpecialties,
            selectedJobCategories,
            startEditing,
            cancelEditing,
            openConfirmationModal,
            allData, formatDate 
        };
    }
};
</script>

<style scoped>
.employee-view {
  max-width: 80vw;
  margin: 0 auto;
  background-color: #fefefe;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
  font-family: "Segoe UI", sans-serif;
}

.profile-section {
  margin-bottom: 2rem;
}

.profile-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-avatar {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
  border: 4px solid #007BFF;
  margin-bottom: 1rem;
}

.employee-name {
  font-size: 1.8rem;
  font-weight: bold;
  color: #333;
}

.employee-info {
  padding: 1rem;
}

.info-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}

.info-block {
  flex: 1 1 45%;
  display: flex;
  flex-direction: row;
}




.info-block label {
  font-weight: 600;
  color: #888;
  font-size: 0.85rem;
  display: block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-block span {
  color: #222;
  font-size: 1rem;
  font-weight: 500;
  margin-left:20px;
  margin-bottom:10px;
}

.employee-view label {
  font-size: 0.85rem;
  color: #666;
  text-transform: uppercase;
  margin-bottom: 0;
}

.employee-view span {
  color: #333;
  font-size: 1rem;
}


</style>
